import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./QuotePanel.css";

/* 스마트스토어 상품의 객단가 — 손님은 "견적 금액 ÷ 객단가" 만큼 수량을 적어 주문한다. */
export const SMARTSTORE_UNIT_PRICE = 100;

/**
 * 스마트스토어 주문서에 옮겨 적을 두 가지(견적번호·주문 수량).
 * 결제 안내이므로 [네이버 스토어에서 결제] 버튼 바로 위에 둔다 (2026-09-08 김현비).
 */
export default function QuoteCopyBox({ quote }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState("");
  const [copyFailed, setCopyFailed] = useState("");

  if (!quote?.orderNum) return null;

  const total = Number(quote.totalPrice || 0);
  const storeQty = Math.max(1, Math.round(total / SMARTSTORE_UNIT_PRICE));

  /* ⛔ navigator.clipboard 는 https(또는 localhost)에서만 있다 — 그것만 쓰면
     사내 미리보기(http://192.168.x)에서 눌러도 아무 일이 안 일어난다. 옛 방식으로 받쳐 준다. */
  async function copyText(key, text) {
    if (!text) return;
    let ok = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        ok = true;
      }
    } catch (err) { ok = false; }
    if (!ok) {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        ok = document.execCommand("copy");
        document.body.removeChild(ta);
      } catch (err) { ok = false; }
    }
    setCopied(ok ? key : "");
    setCopyFailed(ok ? "" : key);
    setTimeout(() => { setCopied(""); setCopyFailed(""); }, 2000);
  }

  const btnLabel = (key) =>
    copied === key ? t("quote.copied", "복사됨 ✓")
      : copyFailed === key ? t("quote.copyFail", "복사 실패")
        : t("quote.copy", "복사");

  return (
    <div className="quote-copy-wrap">
      <p className="quote-copy-guide">
        {t("quote.copyGuide", "스마트스토어 상품은 {{unit}}원 단위로 되어 있습니다. 견적 금액만큼 수량을 넣어 결제해 주세요.", {
          unit: SMARTSTORE_UNIT_PRICE.toLocaleString(),
        })}
      </p>
      <p className="quote-copy-note">
        {t("quote.copyQtyWhy", "아래 수량은 결제를 위한 숫자이고, 쿠키커터 개수가 아닙니다. 만드실 개수는 위 견적서에 있는 그대로 제작됩니다.")}
      </p>
      <dl className="quote-copy-box">
        <div className="quote-copy-row">
          <dt>{t("quote.label", "견적번호")}</dt>
          <dd className="quote-copy-value">{quote.orderNum}</dd>
          <button type="button" className="quote-copy-btn" onClick={() => copyText("no", quote.orderNum)}>
            {btnLabel("no")}
          </button>
        </div>
        <div className="quote-copy-row">
          <dt>{t("quote.storeQty", "스토어 주문 수량")}</dt>
          <dd className="quote-copy-value">
            <b>{storeQty.toLocaleString()}</b>{t("quote.ea", "개")}
          </dd>
          <span className="quote-copy-calc">
            {t("quote.storeQtyHint", "{{unit}}원 × {{qty}}개 = {{total}}원 (견적 금액)", {
              unit: SMARTSTORE_UNIT_PRICE.toLocaleString(),
              qty: storeQty.toLocaleString(),
              total: total.toLocaleString(),
            })}
          </span>
          <button type="button" className="quote-copy-btn" onClick={() => copyText("qty", String(storeQty))}>
            {btnLabel("qty")}
          </button>
        </div>
      </dl>
    </div>
  );
}
